"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpaBootstrapImpl = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var coreHttp = _interopRequireWildcard(require("@azure/core-http"));

var Mappers = _interopRequireWildcard(require("../models/mappers"));

var Parameters = _interopRequireWildcard(require("../models/parameters"));

/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

/** Class containing SpaBootstrap operations. */
var SpaBootstrapImpl = /*#__PURE__*/function () {
  /**
   * Initialize a new instance of the class SpaBootstrap class.
   * @param client Reference to the service client
   */
  function SpaBootstrapImpl(client) {
    (0, _classCallCheck2["default"])(this, SpaBootstrapImpl);
    this.client = client;
  }
  /** @param options The options parameters. */


  (0, _createClass2["default"])(SpaBootstrapImpl, [{
    key: "bootstrap",
    value: function bootstrap(options) {
      var operationArguments = {
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, bootstrapOperationSpec);
    }
  }]);
  return SpaBootstrapImpl;
}(); // Operation Specifications


exports.SpaBootstrapImpl = SpaBootstrapImpl;
var serializer = new coreHttp.Serializer(Mappers,
/* isXml */
false);
var bootstrapOperationSpec = {
  path: "/bootstrap",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: Mappers.SpaConfigDto
    }
  },
  queryParameters: [Parameters.portalId2],
  urlParameters: [Parameters.$host],
  headerParameters: [Parameters.accept],
  serializer: serializer
};